// This icon file is generated automatically.
var PSwitchUserOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.86 4.23a3.87 3.87 0 10-6.14 3.15H4.7a5.82 5.82 0 00-3.58 5.29c0 .07.06.13.13.13h.94c.06 0 .12-.06.12-.13a4.66 4.66 0 014.67-4.56 3.87 3.87 0 003.88-3.88zm-3.88 2.7a2.69 2.69 0 110-5.38 2.69 2.69 0 010 5.37zm1.64 3.45h4.13c.07 0 .13-.06.13-.13v-.88a.13.13 0 00-.13-.12H9.99l.74-.94a.13.13 0 00-.1-.2H9.5a.26.26 0 00-.2.1L8.23 9.56a.5.5 0 00.4.8zm3.76 1H8.25a.13.13 0 00-.13.12v.88c0 .06.06.12.13.12h2.76l-.74.94a.13.13 0 00.1.2h1.13c.08 0 .15-.04.2-.1l1.07-1.36a.5.5 0 00-.4-.8z", "fill-rule": "nonzero" } }] }, "name": "p-switch-user", "theme": "outlined" };
export default PSwitchUserOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSwitchUserOutlined.js
// module id = 3668
// module chunks = 0